'use client'

import type { Ref } from 'react'

import { cx } from '@/app/lib/utils'
import styles from './HamburgerMenu.module.scss'

interface HamburgerMenuProps {
  /** Estado abierto: las barras se transforman en una «X». */
  open: boolean
  onToggle: () => void
  className?: string
  ref?: Ref<HTMLButtonElement>
}

/**
 * Botón de menú (3 barras animadas). En `open` se convierte en una «X».
 * El color se hereda del contenedor (`currentColor`).
 */
export function HamburgerMenu({ open, onToggle, className, ref }: HamburgerMenuProps) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
      aria-expanded={open}
      className={cx(styles.button, open && styles.active, className)}
      onClick={onToggle}
    >
      <span className={styles.bars} aria-hidden="true">
        <span className={styles.bar} />
        <span className={styles.bar} />
        <span className={styles.bar} />
      </span>
    </button>
  )
}
